<template>
  <v-app id="inspire">
    <!-- START - Edited by Dedian 29 Juli 2021 -->
    <v-idle
      @idle="onidle"
      @remind="onremind"
      :loop="true"
      :wait="5"
      :duration="3600"
    />
    <!-- END - Edited by Dedian 29 Juli 2021 -->
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense>
        <template v-for="item in items">
          <v-list-group
            v-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
            color="red darken-1"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              link
              :to="child.link"
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.text" link :to="item.link">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="red darken-1"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <span class="hidden-sm-and-down">iMaps</span>
      </v-toolbar-title>
      <!--<v-text-field flat solo-inverted hide-details prepend-inner-icon="mdi-magnify" label="Search" class="hidden-sm-and-down" />-->
      <v-spacer />
      <!--<v-btn icon>
            <v-icon>mdi-apps</v-icon>
        </v-btn>
        <v-btn icon>
            <v-icon>mdi-bell</v-icon>
        </v-btn>-->
      <v-row>
        <v-col class="text-right" md="12">
          {{ this.username }}
        </v-col>
      </v-row>
      <v-btn @click="logout" icon large>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-content class="grey lighten-4">
      <slot></slot>
    </v-content>
    <!-- Start Validation Submit -->
    <v-dialog v-model="isOpenModalConfirm" persistent max-width="500px">
      <v-card>
        <v-card-title class="headline"
          ><b style="color: red">Session anda telah habis</b></v-card-title
        >

        <v-card-text>
          Silahkan login kembali untuk dapat melanjutkan menggunakan website ini.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <!-- <v-btn color="red darken-1" text @click="isOpenModalConfirm = false"
            >Cancel</v-btn
          > -->

          <v-btn color="red darken-1" text @click="logout">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Validation Submit -->
  </v-app>
</template>

<script>
export default {
  created() {
    const userData = JSON.parse(localStorage.getItem("userData"));
    this.username = userData.USER_NAME + " (" + userData.POSITION_CODE + ")";
  },
  mounted() {
    const MENULIST = JSON.parse(localStorage.getItem("menuList"));

    for (let MENU of MENULIST) {
      if (MENU.PARENT_ID == null) {
        const template = {
          icon: "mdi-chevron-up",
          "icon-alt": "mdi-chevron-down",
          text: MENU.MENU_LIST_DESC,
          namespace: MENU.MENU_LIST_DESC.toLowerCase().split(" ").join("-"),
          model: false,
          children: [],
        };

        MENULIST.find((x) => {
          if (x.PARENT_ID == MENU.MENU_LIST_ID) {
            template.children.push({
              text: x.MENU_LIST_DESC,
              link: x.URL,
            });
          }
        });

        this.items.push(template);
      }
    }

    const namespace = this.$route.path.split("/")[1];
    const indexMenu = this.items.findIndex((obj) => {
      if (namespace == "") {
        return obj.namespace == "main";
      }
      return obj.namespace == namespace;
    });

    if (this.items[indexMenu] == undefined) {
      this.items[0].model = true;
    } else {
      this.items[indexMenu].model = true;
    }
  },
  props: {
    source: String,
  },
  data: () => ({
    isOpenModalConfirm: false,
    username: "",
    dialog: false,
    drawer: null,
    items: [
      {
        icon: "mdi-home",
        text: "Home",
        link: "/",
        namespace: "main",
        model: false,
      },
      //   {
      //     icon: "mdi-chevron-up",
      //     "icon-alt": "mdi-chevron-down",
      //     text: "Manage Role",
      //     namespace: "manage-role",
      //     model: false,
      //     children: [
      //       {
      //         text: "Upload New Role",
      //         link: "/manage-role/upload",
      //       },
      //       {
      //         text: "Add New Role",
      //         link: "/manage-role/new",
      //       },
      //       {
      //         text: "Overview",
      //         link: "/manage-role/overview",
      //       },
      //     ],
      //   },
      //   {
      //     icon: "mdi-chevron-up",
      //     "icon-alt": "mdi-chevron-down",
      //     text: "Mapping Sales Rep",
      //     namespace: "mapping-sales-rep",
      //     model: false,
      //     children: [
      //       {
      //         text: "Overview",
      //         link: "/mapping-sales-rep/overview",
      //       },
      //     ],
      //   },
      //   {
      //     icon: "mdi-chevron-up",
      //     "icon-alt": "mdi-chevron-down",
      //     text: "Mapping Sales Assignment",
      //     namespace: "mapping-sales-assignment",
      //     model: false,
      //     children: [
      //       {
      //         text: "Upload",
      //         link: "/mapping-sales-assignment/upload",
      //       },
      //       {
      //         text: "Add",
      //         link: "/mapping-sales-assignment/new",
      //       },
      //       {
      //         text: "Overview",
      //         link: "/mapping-sales-assignment/overview",
      //       },
      //     ],
      //   },
      //   {
      //     icon: "mdi-chevron-up",
      //     "icon-alt": "mdi-chevron-down",
      //     text: "Target",
      //     namespace: "target",
      //     model: false,
      //     children: [
      //       {
      //         text: "Submit",
      //         link: "/target/submit",
      //       },
      //       {
      //         text: "Overview",
      //         link: "/target/overview",
      //       },
      //     ],
      //   },
      //   {
      //     icon: "mdi-chevron-up",
      //     "icon-alt": "mdi-chevron-down",
      //     text: "Adjust Incentive",
      //     namespace: "adjust-incentive",
      //     model: false,
      //     children: [
      //       {
      //         text: "Upload Incentive",
      //         link: "/adjust-incentive/upload",
      //       },
      //       {
      //         text: "Adjust Incentive",
      //         link: "/adjust-incentive/new",
      //       },
      //       {
      //         text: "Adjust Incentive Summary",
      //         link: "/adjust-incentive/summary",
      //       },
      //     ],
      //   },
      //   {
      //     icon: "mdi-chevron-up",
      //     "icon-alt": "mdi-chevron-down",
      //     text: "Call Management",
      //     namespace: "call-management",
      //     model: false,
      //     children: [
      //       {
      //         text: "Upload Fixed Call",
      //         link: "/call-management/uploadfixedcall",
      //       },
      //     ],
      //   },
      //   {
      //     icon: "mdi-chevron-up",
      //     "icon-alt": "mdi-chevron-down",
      //     text: "CRC",
      //     namespace: "file-viewer",
      //     model: false,
      //     children: [
      //       {
      //         text: "Overview File",
      //         link: "/file-viewer/overview",
      //       },
      //     ],
      //   },
      //   {
      //     icon: "mdi-chevron-up",
      //     "icon-alt": "mdi-chevron-down",
      //     text: "Bisnis Lini Product",
      //     namespace: "mapping-bisnis-lini-product",
      //     model: false,
      //     children: [
      //       {
      //         text: "Upload Bisnis Lini Product",
      //         link: "/mapping-bisnis-lini-product/upload",
      //       },
      //       {
      //         text: "Overview Bisnis Lini Product",
      //         link: "/mapping-bisnis-lini-product/overview",
      //       },
      //     ],
      //   },
    ],
  }),
  methods: {
    logout() {
      localStorage.removeItem("userData");
      this.$router.push({
        name: "Login",
      });
    },
    onidle() {
      // this.logout();
      // alert('You have been logged out');
      this.isOpenModalConfirm = true;
    },
    onremind(time) {
      console.log(time);
      // alert seconds remaining to 00:00
      // alert(time);
    },
  },
};
</script>
